import {GetBusinessOwnEnabledStatus, SubscriptionsApi, Token} from "@devour/client";
import getConfig from "../utils/getConfig";
import {useQuery} from "@tanstack/react-query";

async function fetchSubscriptionTiers(fullToken: Token, limit: number, offset: number, search: string, isActive?: GetBusinessOwnEnabledStatus) {
    return await new SubscriptionsApi(getConfig(fullToken)).getSubscriptions({
        limit,
        offset,
        search,
        isActive: isActive || undefined,
    });
}

function getSubscriptionTiersQuery(fullToken: Token, limit: number, offset: number, search: string, isActive?: GetBusinessOwnEnabledStatus) {
    return {
        queryKey: [
            "get-subscription-tiers",
            fullToken || "anonymous",
            limit,
            offset,
            search,
            isActive,
        ],
        queryFn: () => fetchSubscriptionTiers(fullToken, limit, offset, search, isActive),
        staleTime: 30 * 60000,
    };
}

export function useGetSubscriptionTiers(fullToken: Token, limit: number, offset: number, search: string, isActive?: GetBusinessOwnEnabledStatus) {
    return useQuery(getSubscriptionTiersQuery(fullToken, limit, offset, search, isActive));
}